﻿import { Resposta } from '@app/api/minuta/Resposta';
import { Button, ColumnProps, OptionProps } from '@digital/ui';
import { Table, Tooltip, Switch, Select, Modal, Icon } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Clausula, EnviarParaAprovacaoItemClausula } from '../../../api/minuta/Clausula';
import { cancelarAprovacaoDoItem, UpdateItemOrdem, updateItemRespostas } from '../../../api/minuta/ItemClausula';

import {
  ClausulaIdPorStatus,
  DeleteItem,
  getAllItemByClausulaIdFilter,
  Item,
  ItemChagemBool,
  ItemDependente,
  ItemPai,
  PerfilAcessoClausulaId,
  getAllItemByClausulaIdPorStatus,
  putAtualizarDescricaoItem,
  RespostaChange,
  updateItemDependente,
  updateItemPai,
  updateNaoEditavel,
  updateNaoExcluir,
  updatePerfilRespostanvel,
  updateResposta,
  updateSempreVisivel,
} from '../../../api/minuta/ItemClausula';
import ModalComentarioClausula from './ModalComentarioClausula';
import ModalSelectRespostaTabela from './ModalSelectRespostaTabela';
import update from 'immutability-helper';
import { componentsSorting } from '../../../components/SortingTable';
import { EStatusDoItem } from '@app/enums/EStatusDoItem';

interface TabelaItemProps {
  clausulaResult: Clausula;
  itensRowTable: Item[];
  onUpdateRowTable: (clausulaId: string) => void;
  mostraColunaComentario: boolean;
  perfilResponsavelOptions: OptionProps[];
  clausulasComItensAprovados: OptionProps[];
  atualizarClausulaPendentes: () => void;
  handleModalDescricao: (dados: any) => void;
  statusItemFilter: number[];
  mostrarColunaEvioParaAprovacao: boolean;
  mostarBotaoCancelarAprovacaoAdm?: boolean;
  sempreMostarBotaoExcluir?: boolean;
}

const TabelaItensCadastrados = ({
  clausulaResult,
  itensRowTable,
  onUpdateRowTable,
  mostraColunaComentario,
  perfilResponsavelOptions,
  clausulasComItensAprovados,
  atualizarClausulaPendentes,
  handleModalDescricao,
  statusItemFilter,
  mostrarColunaEvioParaAprovacao,
  mostarBotaoCancelarAprovacaoAdm,
  sempreMostarBotaoExcluir,
}: TabelaItemProps) => {
  const [rowsItem, setRowsItem] = useState<Item[]>([]);
  const { Option } = Select;
  const { confirm } = Modal;

  const [itemListComStatusAprovado, setItemListComStatusAprovado] = useState<OptionProps[]>([]);

  useEffect(() => {
    const rowsFilterStatus = itensRowTable.filter(f => statusItemFilter.indexOf(f.codigoStatus) !== -1);
    setRowsItem(rowsFilterStatus);
  }, [itensRowTable]);

  const getAllOptionProps = (listResult: Item[]) => {
    return listResult.map(t => ({ text: t.descricao, value: t.id.toString() }));
  };

  //filtro pesquisa
  const statusFiltro = [
    {
      text: 'Aguardando aprovação de nivel 1',
      value: '2',
    },
    {
      text: 'Aguardando aprovação de nivel 2',
      value: '3',
    },
    {
      text: 'Reprovado',
      value: '5',
    },
  ];

  const allItemByClausulaIdPorStatus = (itemId: string) => {
    getAllItemByClausulaIdPorStatus({
      clausulaId: itemId,
      stausCodigo: [EStatusDoItem['Aprovado']],
    } as ClausulaIdPorStatus).then(data => {
      if (data) {
        setItemListComStatusAprovado(getAllOptionProps(data));
      } else {
        setItemListComStatusAprovado([]);
      }
    });
  };

  useEffect(() => {
    if (clausulaResult && clausulaResult.id) {
      allItemByClausulaIdPorStatus(clausulaResult.id);
    }
  }, [clausulaResult]);

  const getAllItemPorId = (clausulaId: string) => {
    if (mostraColunaComentario || mostarBotaoCancelarAprovacaoAdm) {
      getAllItemByClausulaIdPorStatus({
        clausulaId: clausulaId,
        stausCodigo: statusItemFilter,
      } as ClausulaIdPorStatus).then(data => {
        if (data) {
          const rowsFilterStatus = data.filter(f => statusItemFilter.indexOf(f.codigoStatus) !== -1);
          setRowsItem(rowsFilterStatus);
        }
      });
    } else {
      getAllItemByClausulaIdFilter(clausulaId).then(data => {
        if (data) {
          const rowsFilterStatus = data.filter(f => statusItemFilter.indexOf(f.codigoStatus) !== -1);
          setRowsItem(rowsFilterStatus);
        }
      });
    }
  };

  const excluirEAtualizar = (item: any) => {
    DeleteItem(item.id).then(dataDelete => {
      if (mostraColunaComentario || mostarBotaoCancelarAprovacaoAdm) {
        getAllItemByClausulaIdPorStatus({
          clausulaId: item.clausulaId,
          stausCodigo: statusItemFilter,
        } as ClausulaIdPorStatus).then(data => {
          if (data) {
            const rowsFilterStatus = data.filter(f => statusItemFilter.indexOf(f.codigoStatus) !== -1);
            setRowsItem(rowsFilterStatus);
          }
        });
      } else {
        getAllItemByClausulaIdFilter(item.clausulaId).then(data => {
          if (data) {
            const rowsFilterStatus = data.filter(f => statusItemFilter.indexOf(f.codigoStatus) !== -1);
            setRowsItem(rowsFilterStatus);
          }
        });
      }
    });
  };

  const enviarParaAprovacao = (item: any) => {
    EnviarParaAprovacaoItemClausula({ id: item.id }).then(data => {
      getAllItemByClausulaIdFilter(item.clausulaId).then(data => {
        if (data) {
          const rowsFilterStatus = data.filter(f => statusItemFilter.indexOf(f.codigoStatus) !== -1);
          setRowsItem(rowsFilterStatus);
        }
      });
      atualizarClausulaPendentes();
    });
  };

  const cancelarAprovacao = (item: any) => {
    cancelarAprovacaoDoItem({ id: item.id }).then(data => {
      getAllItemByClausulaIdFilter(item.clausulaId).then(data => {
        if (data) {
          const rowsFilterStatus = data.filter(f => statusItemFilter.indexOf(f.codigoStatus) !== -1);
          setRowsItem(rowsFilterStatus);
        }
      });
      atualizarClausulaPendentes();
    });
  };

  const handPerfilRespostanvel = (perfilId: string, itemId: string, clausulaId: string) => {
    const changePerfilResponsavel = { perfilAcessoId: perfilId, itemId: itemId } as PerfilAcessoClausulaId;
    updatePerfilRespostanvel(changePerfilResponsavel).then(() => {
      getAllItemPorId(clausulaId);
    });
  };

  const handDependente = (itemDependenteId: string, itemId: string, clausulaId: string) => {
    const changeItemDependete = { itemDependenteId: itemDependenteId, itemId: itemId } as ItemDependente;
    updateItemDependente(changeItemDependete).then(() => {
      getAllItemPorId(clausulaId);
    });
  };

  const handItemPai = (itempaiId: string, itemId: string, clausulaId: string) => {
    const changeItemPai = { itemPaiId: itempaiId, itemId: itemId } as ItemPai;
    updateItemPai(changeItemPai).then(() => {
      getAllItemPorId(clausulaId);
    });
  };

  const handUpdateModalDescricao = (
    html: string,
    text: string,
    clausulaId: string,
    itemId: string,
    codigoStatus: number,
  ) => {
    const dadosModal = {
      title: 'Editar Descrição',
      html: html,
      text: text,
      visible: true,
      onOkRitchTextConteudo: (htmlString: string, textString: string) => {
        if (codigoStatus === 4) {
          confirm({
            title: 'Alteração da descrição do Item.',
            icon: <Icon type="info-circle" />,
            content:
              'Para alterar a descrição do item é necessário gerar uma nova revisão que ficará pendente de envio para aprovação, deseja continuar?',
            onOk() {
              const novoItem = {
                id: itemId,
                descricao: textString,
                descricaoHtml: htmlString,
              } as Item;

              putAtualizarDescricaoItem(novoItem).then((data: any) => {
                if (data) {
                  getAllItemPorId(clausulaId);
                }
              });
            },
            onCancel() {},
          });
        } else {
          const novoItem = {
            id: itemId,
            descricao: textString,
            descricaoHtml: htmlString,
          } as Item;

          putAtualizarDescricaoItem(novoItem).then((data: any) => {
            if (data) {
              getAllItemPorId(clausulaId);
            }
          });
        }
      },
    };

    handleModalDescricao(dadosModal);
  };

  const handUpdateSempreVisivel = (values: ItemChagemBool, clausulaId: string) => {
    updateSempreVisivel(values).then(() => {
      onUpdateRowTable(clausulaId);
      getAllItemPorId(clausulaId);
    });
  };

  const handUpdateItemRespostas = (respostasId: string[], itemId: string, clausulaId: string) => {
    updateItemRespostas({
      itemId: itemId,
      respostasId: respostasId,
    } as RespostaChange).then(() => {
      onUpdateRowTable(clausulaId);
      getAllItemPorId(clausulaId);
    });
  };

  const handUpdateNaoEditavel = (values: ItemChagemBool, clausulaId: string) => {
    updateNaoEditavel(values).then(() => {
      onUpdateRowTable(clausulaId);
      getAllItemPorId(clausulaId);
    });
  };

  const handUpdateNaoExcluir = (values: ItemChagemBool, clausulaId: string) => {
    updateNaoExcluir(values).then(() => {
      onUpdateRowTable(clausulaId);
      getAllItemPorId(clausulaId);
    });
  };

  const collunsTable = () => {
    const colluns: ColumnProps<any>[] = [];

    colluns.push(
      {
        title: 'Ordenação',
        dataIndex: 'ordem',
        width: '1%',
      },
      {
        title: 'Descrição',
        dataIndex: 'descricao',
        width: '18%',
        render: (index: any, record: any, rowKey: any) => {
          return (
            <div
              className="remove-css"
              dangerouslySetInnerHTML={{ __html: record.descricao }}
              onClick={() =>
                handUpdateModalDescricao(
                  record.descricaoHtml,
                  record.descricao,
                  record.clausulaId,
                  record.id,
                  record.codigoStatus,
                )
              }
            />
          );
        },
      },
      {
        title: 'Perfil responsável',
        dataIndex: 'perfilAcessoNome',
        width: '15%',
        render: (text: any, record: Item, index: number) => {
          return (
            <Select
              defaultValue={record.perfilAcessoId}
              style={{ width: '100%' }}
              onChange={(e: string) => {
                handPerfilRespostanvel(e, record.id, record.clausulaId);
              }}>
              {perfilResponsavelOptions.map(perfil => {
                return <Option value={perfil.value}>{perfil.text}</Option>;
              })}
            </Select>
          );
        },
      },
      {
        title: 'Sempre visível',
        width: '15%',
        align: 'center',
        render: (text: any, record: Item, index: number) => {
          return (
            <ModalSelectRespostaTabela
              item={record}
              handUpdateSempreVisivel={handUpdateSempreVisivel}
              ehColunaResposta={false}
              onGetRespostasSelecionadas={respostas => {
                const respostasId = respostas.map(resposta => resposta.id);
                handUpdateItemRespostas(respostasId, record.id, record.clausulaId);
              }}
            />
          );
        },
      },
      {
        title: 'Não Editar',
        width: '15%',
        align: 'center',
        render: (text: any, record: Item, index: number) => {
          return (
            <Switch
              defaultChecked={record.editavel}
              checked={record.editavel}
              key="naoEditar"
              onChange={() => {
                const itemChange = {
                  id: record.id,
                  valor: !record.editavel,
                } as ItemChagemBool;

                handUpdateNaoEditavel(itemChange, record.clausulaId);
              }}
            />
          );
        },
      },
      {
        title: 'Não Excluir',
        width: '15%',
        align: 'center',
        render: (text: any, record: Item, index: number) => {
          return (
            <Switch
              defaultChecked={record.excluivel}
              checked={record.excluivel}
              key="naoExcluir"
              onChange={() => {
                const itemChange = {
                  id: record.id,
                  valor: !record.excluivel,
                } as ItemChagemBool;

                handUpdateNaoExcluir(itemChange, record.clausulaId);
              }}
            />
          );
        },
      },
      {
        title: 'Respostas',
        width: '1%',
        render: (text: any, record: Item, index: number) => {
          return (
            <ModalSelectRespostaTabela
              item={record}
              handUpdateSempreVisivel={handUpdateSempreVisivel}
              ehColunaResposta={true}
              onGetRespostasSelecionadas={respostas => {
                const respostasId = respostas.map(resposta => resposta.id);
                handUpdateItemRespostas(respostasId, record.id, record.clausulaId);
              }}
            />
          );
        },
      },
      {
        title: 'Item Pai',
        width: '15%',
        render: (text: any, record: Item, index: number) => {
          return (
            <Select
              allowClear={true}
              defaultValue={record.itemPaiDescricao}
              style={{ width: '100%' }}
              onChange={(e: string) => {
                handItemPai(e, record.id, record.clausulaId);
              }}>
              {itemListComStatusAprovado.map(itemPai => {
                return itemPai.value !== record.id && <Option value={itemPai.value}>{itemPai.text}</Option>;
              })}
            </Select>
          );
        },
      },
      {
        title: 'Dependente',
        width: '1%',
        render: (text: any, record: Item, index: number) => {
          return (
            <Select
              defaultValue={record.dependenteId}
              style={{ width: '100%' }}
              onChange={(e: string) => {
                handDependente(e, record.id, record.clausulaId);
              }}
              allowClear={true}>
              {clausulasComItensAprovados.map(dependete => {
                return <Option value={dependete.value}>{dependete.text}</Option>;
              })}
            </Select>
          );
        },
      },
      {
        //filtro pesquisa
        title: 'Status',
        dataIndex: 'status',
        width: '1%',
        filters: statusFiltro || [],
        filterMultiple: true,
        filterIcon: filtered => <Icon type="filter" style={{ minWidth: 'auto', border: 'none' }} />,
        onFilter: (value, record) => value == record.codigoStatus,
      },
      {
        title: 'Revisão',
        dataIndex: 'revisao',
        width: '1%',
      },
    );

    colluns.push({
      title: 'Comentário',
      width: '1%',
      render: (text: any, record: Item, index: number) => {
        return <ModalComentarioClausula itemId={record.id} contemComentario={record.contemComentario} />;
      },
    });

    colluns.push({
      title: 'Ações',
      width: '1%',
      dataIndex: 'acoes',
      key: 'acoes',
      render: (text: any, record: Item, index: number) => {
        return retornarColunasAcoes(text, record, index);
      },
    });

    return colluns;
  };

  function confirmacaoEnvioParaAprovacaoAdm(record: Item) {
    confirm({
      title: 'Esta ação ira mudar o status deste item para "Aguardando aprovação de nivel 1". Deseja continuar?',
      icon: <Icon type="info-circle" />,
      onOk() {
        enviarParaAprovacao(record);
      },
      onCancel() {},
    });
  }

  function cancelaEnvioParaAprovacaoAdm(record: Item) {
    confirm({
      title: 'Cancelar aprovação',
      icon: <Icon type="info-circle" />,
      content: 'Esta ação ira mudar o status deste item para "Pendente de envio para Aprovação".Deseja continuar?',
      onOk() {
        cancelarAprovacao(record);
      },
      onCancel() {},
    });
  }

  function excluirItem(record: Item) {
    confirm({
      title: 'Excluir Item',
      icon: <Icon type="info-circle" />,
      content: 'Essa ação excluirá o item selecionado e todos os seus filhos, deseja confirmar a exclusão?',
      onOk() {
        excluirEAtualizar(record);
      },
      onCancel() {},
    });
  }

  const retornarColunasAcoes = (text: any, record: Item, index: number) => {
    let collunas = [];

    const ehStatusReprovado = record.codigoStatus === EStatusDoItem['Reprovado'];
    const ehStatusAguardandoAprovacaonivel1Ou2 =
      record.codigoStatus === EStatusDoItem['AprovacaoClausulaNivel1'] ||
      record.codigoStatus === EStatusDoItem['AprovacaoClausulaNivel2'];

    if (mostrarColunaEvioParaAprovacao || ehStatusReprovado) {
      const titleTooltip = ehStatusReprovado ? 'Reenviar' : 'Enviar';
      collunas.push(
        <Tooltip title={`${titleTooltip} para aprovação`}>
          <Button
            type="link"
            icon="messaging-send"
            size="large"
            onClick={() => confirmacaoEnvioParaAprovacaoAdm(record)}
          />
        </Tooltip>,
      );
    }

    if (ehStatusAguardandoAprovacaonivel1Ou2 || (mostarBotaoCancelarAprovacaoAdm && !ehStatusReprovado)) {
      collunas.push(
        <Tooltip title="Cancelar Aprovação">
          <Button
            type="link"
            icon="messaging-cancel_subscription"
            size="large"
            onClick={() => cancelaEnvioParaAprovacaoAdm(record)}
          />
        </Tooltip>,
      );
    }

    if (sempreMostarBotaoExcluir || ehStatusReprovado || record.codigoStatus === EStatusDoItem['Aprovado']) {
      collunas.push(
        <>
          <Tooltip title="Excluir">
            <Button type="link" icon="files-delete" size="large" onClick={() => excluirItem(record)} />
          </Tooltip>
        </>,
      );
    }

    return collunas;
  };

  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = rowsItem[dragIndex];
      const respUpdate = update(rowsItem, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRow],
        ],
      });

      const ordem = respUpdate.map((ru, index) => {
        return { ...ru, ordenacao: index + 1 };
      });

      UpdateItemOrdem({ ordem }).then(() => {
        getAllItemPorId(clausulaResult.id);
      });
    },
    [rowsItem],
  );

  return (
    <DndProvider backend={HTML5Backend}>
      <Table
        rowKey={'id'}
        dataSource={rowsItem}
        columns={collunsTable()}
        components={componentsSorting}
        pagination={false}
        onRow={(record, index) => ({
          index,
          moveRow,
        })}
      />
    </DndProvider>
  );
};

export default TabelaItensCadastrados;
